export default __webpack_public_path__ + "static/media/github (1).553c6615.png";